module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"100\" height=\"94.578\" viewBox=\"0 0 100 94.578\"><path d=\"M98.608 62.532L74.79 38.668a4.76 4.76 0 1 0-6.74 6.728l15.71 15.737H9.523V4.763a4.76 4.76 0 0 0-9.522 0v61.132a4.76 4.76 0 0 0 4.76 4.762h79.067l-15.645 15.81a4.76 4.76 0 0 0 3.385 8.11 4.74 4.74 0 0 0 3.384-1.412l23.674-23.922a4.76 4.76 0 0 0-.015-6.71z\"/></svg>"


/*****************
 ** WEBPACK FOOTER
 ** ./~/seek-style-guide/react/icons/DownRightArrowIcon/DownRightArrowIcon.svg
 ** module id = 637
 ** module chunks = 0
 **/